// src/pages/Nosotros.js
import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../styles/Nosotros.css';
import bannerImage from '../assets/bannernosotros.jpg'; // Asegúrate de que la ruta sea correcta
import misionImage from '../assets/mision.png'; // Asegúrate de que la ruta sea correcta
import visionImage from '../assets/vision.png'; // Asegúrate de que la ruta sea correcta
import politicaImage from '../assets/politica.png'; // Asegúrate de que la ruta sea correcta

const Nosotros = () => {
  return (
    <>
      <div className="banner">
        <img src={bannerImage} alt="Banner" className="banner-image" />
      </div>
      <div className="gray-background">
        <div className="text-container">
          <h1>Quiénes somos</h1>
          <p>
            El Centro Analítico de Patología inició sus funciones en el año de 1990, como una microempresa. Durante 5 años se localizó en área anexa al Hospital Terranova.
            En el año de 1995 se transformó en Sociedad Anónima de Capital Variable y cambió su domicilio a la localización actual. Prestamos servicio de Laboratorio al Hospital
            Terranova las 24 hrs. del día durante todo el año. Otorgamos servicios al público en general las 24 hrs. de los 365 días del año. Y en las mismas condiciones desde
            nuestra fundación hasta los días de hoy prestamos Servicios Subrogados en análisis de rutina y especiales a otros laboratorios privados e institucionales. El trabajo
            del laboratorio desde sus inicios ha contado con personal de alta calidad técnica con infraestructura tecnológica actualizada, aunado a la honestidad y precios justos.
            Llevamos un Control de Calidad analítico durante el proceso de muestras para asegurar la veracidad de los resultados de pacientes y los resultados sean médicamente útiles.
            Nuestros procesos actuales de operación están directamente ligados a los lineamientos y normas que exige la Secretaría de Salud NOM 007 SSA1 2008 y el ISO 15189.
          </p>
        </div>
      </div>
      <Container fluid>
        <Row className="justify-content-center text-center custom-row">
          <Col md={4} className="custom-card-col">
            <Card className="h-100 custom-card">
              <Card.Img variant="top" src={misionImage} className="custom-card-image" />
              <Card.Body>
                <Card.Title>Misión</Card.Title>
                <Card.Text className="text-justify">
                  Laboratorio de Análisis Clínicos con actitud de servicio y calidad.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="custom-card-col">
            <Card className="h-100 custom-card">
              <Card.Img variant="top" src={visionImage} className="custom-card-image" />
              <Card.Body>
                <Card.Title>Visión</Card.Title>
                <Card.Text className="text-justify">
                  Nuestra Meta debe ser la Confiabilidad de nuestros resultados a precios accesibles.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="custom-card-col">
            <Card className="h-100 custom-card">
              <Card.Img variant="top" src={politicaImage} className="custom-card-image" />
              <Card.Body>
                <Card.Title>Política de Calidad</Card.Title>
                <Card.Text className="text-justify">
                  El Director General y todo el personal de Centro Analítico de Patología estamos comprometidos en otorgar la óptima asistencia de Laboratorio a nuestros pacientes
                  con los requisitos establecidos con la Normas Mexicanas y Leyes Aplicables mediante el SGC basado en la IS0 15189, Control de Calidad y Análisis de Riesgos, mejorando
                  los servicios de Laboratorio a través de las mejora continua, otorgando confiabilidad, confidencialidad e imparcialidad de los resultados del Laboratorio.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Nosotros;
